
import Cookies from 'js-cookie'

const TokenKey = 'token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token:any) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
 
 
export function setUserName(token:any) {
  return Cookies.set("userName", token)
}

export function getUserName() {
  return Cookies.get("userName")
}
 





